import { Spinner } from '@ds';

export const TabLoadingState = () => (
  <div className="flex justify-center py-8">
    <Spinner size="sm" />
  </div>
);
